"use client";

import Link from "next/link";
import { BillingCheckoutButton } from "@/components/BillingActions";

type Plan = "SOLO" | "TEAM";

export function PricingCTA({
  plan,
  isAgent,
  isLoggedIn,
  featured,
  teamSeats = 3,
}: {
  plan: Plan | "BROKERAGE";
  isAgent: boolean;
  isLoggedIn: boolean;
  featured?: boolean;
  teamSeats?: number;
}) {
  const baseClass = featured
    ? "bg-emerald-600 text-white hover:bg-emerald-700"
    : "border border-slate-300 text-slate-700 hover:bg-slate-50";

  if (plan === "BROKERAGE") {
    return (
      <a
        href="mailto:sales@closinglane.app?subject=ClosingLane%20Brokerage%20plan"
        className={`mt-8 block rounded-lg px-4 py-2.5 text-center text-sm font-semibold ${baseClass}`}
      >
        Contact us
      </a>
    );
  }

  if (isLoggedIn && isAgent) {
    return (
      <div className="mt-8">
        <BillingCheckoutButton
          plan={plan}
          seatCount={plan === "TEAM" ? teamSeats : undefined}
          label={
            plan === "SOLO"
              ? "Start 60-day free trial — Solo"
              : `Start 60-day free trial — Team (${teamSeats} seats)`
          }
          className={`w-full rounded-lg px-4 py-2.5 text-center text-sm font-semibold disabled:opacity-60 ${baseClass}`}
        />
      </div>
    );
  }

  const href = plan === "SOLO" ? "/register?plan=solo" : "/register?plan=team";
  return (
    <Link
      href={href}
      className={`mt-8 block rounded-lg px-4 py-2.5 text-center text-sm font-semibold ${baseClass}`}
    >
      Start 60-day free trial
    </Link>
  );
}
